 
// ─── UI catalogs + sample data ─────────────────────────────────────────
// After the move to a real backend, this module only carries client-side
// rendering metadata (step catalog, summaries, filename tokens) and a few
// small sample datasets used by the in-browser preview. The pipeline
// engine, project catalog, organisations, and run history all live on the
// server now — see server/app/seed.py and server/app/engine/.

// Source CSV: a messy customer/CRM extract. Used as the default in-browser
// preview input until the user uploads their own file.
export const SOURCE_ROWS = [
  { id: 1001, name: 'Lena Park', email: 'lena.park@northwind.io', company: 'Northwind Logistics', country: 'US', status: 'active', plan: 'Pro', mrr: '$480', signup: '2024-09-12' },
  { id: 1002, name: '  ricardo gomez', email: 'Ricardo.Gomez@aerospan.com ', company: 'Aerospan', country: 'mx', status: 'active', plan: 'Team', mrr: '$240', signup: '2024-09-14' },
  { id: 1003, name: 'Mei Tanaka', email: 'mei.tanaka@orbital.jp', company: 'Orbital Foundry', country: 'JP', status: 'active', plan: 'Enterprise', mrr: '$1,850', signup: '2024-07-02' },
  { id: 1004, name: 'Sven Borg', email: 'sven@halgen.se', company: 'Halgen Industries', country: 'SE', status: 'trial', plan: 'Pro', mrr: '$0', signup: '2025-01-19' },
  { id: 1005, name: 'Lena Park', email: 'lena.park@northwind.io', company: 'Northwind Logistics', country: 'US', status: 'active', plan: 'Pro', mrr: '$480', signup: '2024-09-12' },
  { id: 1006, name: 'Priya Subramanian', email: 'priya.s@meridian.in', company: 'Meridian Steel', country: 'IN', status: 'active', plan: 'Team', mrr: '$240', signup: '2024-11-04' },
  { id: 1007, name: 'INTERNAL TEST', email: 'qa+test1@datapipeline.io', company: 'Internal', country: 'US', status: 'active', plan: 'Pro', mrr: '$0', signup: '2025-02-01' },
  { id: 1008, name: 'Adaeze Okafor', email: 'a.okafor@savanco.ng', company: 'Savanco Energy', country: 'NG', status: 'active', plan: 'Enterprise', mrr: '$2,100', signup: '2024-05-22' },
  { id: 1009, name: 'Hassan Khalil', email: 'hassan@levanteq.com', company: 'LevantEQ', country: 'AE', status: 'cancelled', plan: 'Team', mrr: '$0', signup: '2024-03-11' },
  { id: 1010, name: 'Brigitte Laurent', email: 'brigitte.l@cogec.fr', company: 'Cogec Marine', country: 'FR', status: 'active', plan: 'Pro', mrr: '$480', signup: '2024-10-30' },
  { id: 1011, name: 'Mei Tanaka', email: 'MEI.TANAKA@orbital.jp', company: 'Orbital Foundry', country: 'JP', status: 'active', plan: 'Enterprise', mrr: '$1,850', signup: '2024-07-02' },
  { id: 1012, name: 'Jonas Berger', email: 'jonas@krautwerk.de', company: 'Krautwerk GmbH', country: 'DE', status: 'active', plan: 'Team', mrr: '$240', signup: '2024-12-18' },
  { id: 1013, name: 'Olu Adeyemi', email: '', company: 'Mantis Robotics', country: 'NG', status: 'trial', plan: 'Pro', mrr: '$0', signup: '2025-02-08' },
  { id: 1014, name: 'Sofia Castellanos', email: 'sofia.c@andesline.cl', company: 'Andesline', country: 'CL', status: 'active', plan: 'Pro', mrr: '$480', signup: '2024-08-14' },
  { id: 1015, name: 'INTERNAL TEST', email: 'qa+test2@datapipeline.io', company: 'Internal', country: 'US', status: 'active', plan: 'Pro', mrr: '$0', signup: '2025-02-04' },
  { id: 1016, name: 'Daniel Voss', email: 'd.voss@helixmotion.com', company: 'Helix Motion', country: 'US', status: 'active', plan: 'Enterprise', mrr: '$2,100', signup: '2024-04-08' },
  { id: 1017, name: 'Yuki Sato', email: 'yuki@kanagawaforge.jp', company: 'Kanagawa Forge', country: 'JP', status: 'cancelled', plan: 'Team', mrr: '$0', signup: '2024-02-19' },
  { id: 1018, name: 'Brigitte Laurent', email: 'brigitte.l@cogec.fr', company: 'Cogec Marine', country: 'FR', status: 'active', plan: 'Pro', mrr: '$480', signup: '2024-10-30' },
  { id: 1019, name: 'Anika Schmidt', email: 'anika@nordforge.de ', company: 'Nordforge', country: 'DE', status: 'trial', plan: 'Pro', mrr: '$0', signup: '2025-01-28' },
  { id: 1020, name: 'rafael Costa', email: 'rafael.costa@tropico.br', company: 'Tropico Foods', country: 'BR', status: 'active', plan: 'Team', mrr: '$240', signup: '2024-11-22' },
  { id: 1021, name: 'Inga Halvorsen', email: 'inga@haldenmar.no', company: 'Haldenmar', country: 'NO', status: 'active', plan: 'Pro', mrr: '$480', signup: '2024-06-30' },
  { id: 1022, name: 'Tomás Reyes', email: 'tomas.r@altiplano.pe', company: 'Altiplano Mining', country: 'PE', status: 'active', plan: 'Enterprise', mrr: '$2,100', signup: '2024-05-15' },
  { id: 1023, name: 'Adaeze Okafor', email: 'a.okafor@savanco.ng', company: 'Savanco Energy', country: 'NG', status: 'active', plan: 'Enterprise', mrr: '$2,100', signup: '2024-05-22' },
  { id: 1024, name: 'Marisol Villar', email: 'marisol@solarcrest.es', company: 'Solarcrest', country: 'ES', status: 'active', plan: 'Pro', mrr: '$480', signup: '2024-09-03' },
];

export const SOURCE_COLUMNS = [
  { name: 'id', type: 'number' },
  { name: 'name', type: 'string' },
  { name: 'email', type: 'string' },
  { name: 'company', type: 'string' },
  { name: 'country', type: 'string' },
  { name: 'status', type: 'string' },
  { name: 'plan', type: 'string' },
  { name: 'mrr', type: 'string' },
  { name: 'signup', type: 'string' },
];

// ── Operator catalog (filter / case_when) ───────────────────────────────
export const OPERATORS = [
  { id: 'eq', label: 'equals', needsValue: true },
  { id: 'neq', label: 'not equals', needsValue: true },
  { id: 'contains', label: 'contains', needsValue: true },
  { id: 'ncontains', label: 'does not contain', needsValue: true },
  { id: 'starts', label: 'starts with', needsValue: true },
  { id: 'ends', label: 'ends with', needsValue: true },
  { id: 'matches', label: 'matches regex', needsValue: true },
  { id: 'gt', label: '>', needsValue: true },
  { id: 'gte', label: '≥', needsValue: true },
  { id: 'lt', label: '<', needsValue: true },
  { id: 'lte', label: '≤', needsValue: true },
  { id: 'blank', label: 'is blank', needsValue: false },
  { id: 'notblank', label: 'is not blank', needsValue: false },
  { id: 'in', label: 'is one of', needsValue: true },
  { id: 'nin', label: 'is not one of', needsValue: true },
  // exists-in-source takes a source + source column instead of a value, and
  // between takes two bounds (value, value2) — ConditionRows renders both.
  { id: 'in_source', label: 'exists in source', needsValue: false },
  { id: 'nin_source', label: 'not in source', needsValue: false },
  { id: 'between', label: 'is between', needsValue: true },
  { id: 'nbetween', label: 'is not between', needsValue: true },
];

// ── Build canonical pipeline order ──────────────────────────────────────
// Used by the canvas, outline, and inspector — kept client-side because
// it's a pure ordering helper, not engine logic.
export function pipelineOrder(steps) {
  return [...steps].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

// ── Feature-engineering gate ─────────────────────────────────────────────
// Scaling/encoding steps fit their stats (mean/std/median/IQR/min/max,
// encoding categories) from train rows only — that requires a "split"
// column already present on the rows arriving at them, which only exists
// once a Train/Test Split step has run earlier in the pipeline. Mirrors
// addStep's own anchor-point logic (App.jsx) so the gate checks the same
// insertion position a new step would actually land at, not just "does a
// split exist anywhere."
export function hasUpstreamSplit(steps, selectedId) {
  const sorted = pipelineOrder(steps);
  const selected = sorted.find(s => s.id === selectedId);
  const anchor = (selected && selected.type !== 'output')
    ? selected
    : [...sorted].reverse().find(s => s.type !== 'output') || sorted[0];
  const anchorOrder = anchor ? anchor.order : -1;
  return sorted.some(s => s.type === 'split_dataset' && s.order <= anchorOrder);
}

// Same-kind name match — used by the upload modal to find which existing
// sheets an upload would replace (it asks the user to confirm first).
// Case-insensitive; returns the EXISTING name in its original casing.
export function findSheetNameCollision(existingNames, name) {
  const target = (name || '').trim().toLowerCase();
  if (!target) return null;
  for (const existing of existingNames) {
    if (existing.trim().toLowerCase() === target) return existing;
  }
  return null;
}

// ── Source registry (client mirror of server/app/engine/registry.py) ──
// Sheets, uploaded files (secondaryDatasets) and step outputs
// (config.output_name) share one namespace: names match case-insensitively
// and must be unique across kinds. The server enforces it on write
// (routers/datasets.py, routers/pipelines.py); these helpers drive the
// matching UI checks and the one Source list SourceSelect renders.
export const SOURCE_KIND_LABELS = { sheet: 'sheet', file: 'uploaded file', step: 'step output' };

export function sourceKey(name) {
  return String(name ?? '').trim().toLowerCase();
}

export function buildSourceEntries({ sheets, secondaryDatasets, steps } = {}) {
  const entries = [];
  for (const [name, v] of sheets || []) entries.push({ name, kind: 'sheet', columns: v.columns });
  for (const [name, v] of secondaryDatasets || []) entries.push({ name, kind: 'file', columns: v.columns });
  for (const step of steps || []) {
    const name = (step.config?.output_name || '').trim();
    if (name) entries.push({ name, kind: 'step', step });
  }
  return entries;
}

export function findSourceEntry(entries, name) {
  const key = sourceKey(name);
  return key ? entries.find(e => sourceKey(e.name) === key) || null : null;
}

// The entry a new name of `kind` would clash with: any entry of another
// kind, or another step's Output Name. A same-kind sheet/file match is a
// replacement, not a clash — the upload modal confirms those instead.
export function findSourceNameOwner(entries, name, { kind, stepId } = {}) {
  const key = sourceKey(name);
  if (!key) return null;
  return entries.find(e => sourceKey(e.name) === key
    && (e.kind !== kind || (kind === 'step' && e.step?.id !== stepId))) || null;
}

export function sourceNameTakenMessage(name, owner) {
  const holder = owner.kind === 'step'
    ? `the Output Name of step "${owner.step?.label || owner.step?.type}"`
    : `used by a ${SOURCE_KIND_LABELS[owner.kind]} ("${owner.name}")`;
  return `"${(name || '').trim()}" is already ${holder}. Source names must be unique across sheets, `
    + 'uploaded files, and step outputs (matching is case-insensitive) — rename one of them.';
}

export function replaceConfirmMessage(names) {
  return `This will replace the existing ${names.map(n => `“${n}”`).join(', ')} — continue or rename?`;
}

// Names that can never be assigned to a sheet, file or Output Name — hard
// rejection, matched case-insensitively. "__self__" is the Source value
// meaning "this step's own rows", so a dataset with that name could never
// be selected. Mirrors RESERVED_SOURCE_NAMES in server/app/engine/registry.py.
const RESERVED_SHEET_NAMES = ['payload', '__self__'];

export function isReservedSheetName(name) {
  return RESERVED_SHEET_NAMES.includes((name || '').trim().toLowerCase());
}

export function reservedSheetNameWarning(name) {
  return `"${(name || '').trim()}" is a reserved name and can't be used for a sheet.`;
}

// Same reserved-name list, worded for a step config field rather than a
// sheet. Used by every step's Output Name / Output Column Name fields
// (server/app/routers/pipelines.py hard-rejects the same names at save
// time — this is the matching client-side check, shown as the user types
// rather than only surfacing on the save-failure toast).
export function reservedFieldNameWarning(name, fieldLabel) {
  return `"${(name || '').trim()}" is a reserved name and can't be used for ${fieldLabel}.`;
}

// A step's Output Name publishes its result into the same registry as
// sheets, uploaded files, and every other step's Output Name (see
// buildSourceEntries above) — names must be unique across all of them
// (server/app/engine/registry.py; server/app/routers/pipelines.py hard-
// rejects a clash with a 409 at save time). This is the matching
// client-side check, shown as the user types rather than only surfacing on
// the save-failure toast. Output Column Name (a column, not a Source)
// doesn't participate in this namespace.
export function outputNameIssue(name, { sheets, secondaryDatasets, steps, stepId } = {}) {
  const trimmed = (name || '').trim();
  if (!trimmed) return null;
  if (isReservedSheetName(trimmed)) {
    return { level: 'error', message: reservedFieldNameWarning(trimmed, 'Output Name') };
  }
  const owner = findSourceNameOwner(
    buildSourceEntries({ sheets, secondaryDatasets, steps }),
    trimmed,
    { kind: 'step', stepId },
  );
  if (owner) {
    return { level: 'error', message: sourceNameTakenMessage(trimmed, owner) };
  }
  return null;
}

// Output Column Name only needs the reserved-word check — it names a
// column, not a Source, so it never collides with the sheet/secondaryDatasets
// namespace the way Output Name does.
export function outputColumnNameIssue(name) {
  const trimmed = (name || '').trim();
  if (!trimmed) return null;
  if (isReservedSheetName(trimmed)) {
    return { level: 'error', message: reservedFieldNameWarning(trimmed, 'Output Column Name') };
  }
  return null;
}

// ─── CATEGORIES (palette grouping) ─────────────────────────────────────
export const CATEGORIES = {
  ingestion: { label: 'Ingestion', icon: 'FileInput', accent: '#60a5fa', desc: 'Connect to files or external sources' },
  cleaning: { label: 'Cleaning', icon: 'Eraser', accent: '#34d399', desc: 'Nulls, whitespace, casing, duplicates' },
  typing: { label: 'Type & parse', icon: 'Type', accent: '#5eead4', desc: 'Cast and parse string values into typed data' },
  transform: { label: 'Row transform', icon: 'Wand2', accent: '#a78bfa', desc: 'Filter, derive, regex, hash, lookups' },
  columns: { label: 'Columns', icon: 'Columns3', accent: '#c084fc', desc: 'Rename, reorder, split, merge' },
  aggregate: { label: 'Aggregate', icon: 'Sigma', accent: '#f472b6', desc: 'Group, window, rolling totals' },
  sort: { label: 'Sort & rank', icon: 'ArrowUpDown', accent: '#fbbf24', desc: 'Order rows, top/bottom N' },
  join: { label: 'Join & combine', icon: 'Combine', accent: '#fb923c', desc: 'Join datasets, append, fuzzy match' },
  reshape: { label: 'Reshape', icon: 'Shuffle', accent: '#e879f9', desc: 'Pivot, unpivot, explode arrays' },
  validate: { label: 'Validate', icon: 'ShieldCheck', accent: '#facc15', desc: 'Schema, regex, range, assertions' },
  enrich: { label: 'Enrich', icon: 'Sparkles', accent: '#22d3ee', desc: 'Geocode, currency, ML classification' },
  feature_engineering: {
    label: 'Feature Engineering',
    icon: 'Settings2',
    accent: '#6366f1',
    desc: 'Feature scaling, encoding, outlier handling, and feature selection',
    subCategories: {
      scaling: { label: 'Scaling', icon: 'Scale' },
      encoding: { label: 'Encoding', icon: 'Tag' },
      outlier_handling: { label: 'Outlier Handling', icon: 'Scissors' },
      feature_selection: { label: 'Feature Selection', icon: 'Target' },
      text_features: { label: 'Text Features & Extraction', icon: 'FileText' },
      skew_correction: { label: 'Distribution & Skew Correction', icon: 'Ruler' }
    }
  },
  sample: { label: 'Sample / split', icon: 'Split', accent: '#94a3b8', desc: 'Random sample, train/test split' },
  profile: { label: 'Profile', icon: 'BarChart3', accent: '#818cf8', desc: 'Column stats and outlier detection' },
  output: { label: 'Output', icon: 'Upload', accent: '#f87171', desc: 'Write results to files or downstream systems' },
};

// ─── STEP_TYPES (full catalog) ─────────────────────────────────────────
// `accent` falls back to the category accent in render code.
export const STEP_TYPES = {
  // Ingestion ─────────────────────────────────────────────────────────
  source: { cat: 'ingestion', label: 'Source file', icon: 'FileInput', shortDesc: 'CSV / TSV / JSON / Parquet input' },
  source_url: { cat: 'ingestion', label: 'URL source', icon: 'Globe', shortDesc: 'Fetch input from an HTTPS URL' },
  source_cloud: { cat: 'ingestion', label: 'Cloud storage', icon: 'Cloud', shortDesc: 'S3 / GCS / Azure Blob input' },

  // Cleaning ──────────────────────────────────────────────────────────
  dedupe: { cat: 'cleaning', label: 'Remove duplicates', icon: 'CopyMinus', shortDesc: 'Drop duplicate rows by key columns' },
  drop_nulls: { cat: 'cleaning', label: 'Drop nulls', icon: 'CircleSlash', shortDesc: 'Drop rows with blanks in selected columns' },
  fill_nulls: { cat: 'cleaning', label: 'Fill nulls', icon: 'CirclePlus', shortDesc: 'Replace blanks with constant / mean / mode' },
  trim: { cat: 'cleaning', label: 'Trim whitespace', icon: 'Scissors', shortDesc: 'Strip leading & trailing whitespace' },
  case: { cat: 'cleaning', label: 'Standardize case', icon: 'CaseSensitive', shortDesc: 'Upper / lower / title' },
  strip_chars: { cat: 'cleaning', label: 'Strip characters', icon: 'Delete', shortDesc: 'Remove unwanted characters' },
  left_trim: { cat: 'cleaning', label: 'Left trim', icon: 'ArrowLeftToLine', shortDesc: 'Strip leading whitespace only' },
  right_trim: { cat: 'cleaning', label: 'Right trim', icon: 'ArrowRightToLine', shortDesc: 'Strip trailing whitespace only' },
  mid: { cat: 'cleaning', label: 'Mid (substring)', icon: 'Crop', shortDesc: 'Extract substring by position' },
  find_replace: { cat: 'cleaning', label: 'Find & replace', icon: 'Replace', shortDesc: 'Replace sub-text in a column' },

  // Type & parse ──────────────────────────────────────────────────────
  cast_type: { cat: 'typing', label: 'Cast type', icon: 'ArrowLeftRight', shortDesc: 'String ↔ number ↔ bool ↔ date' },
  parse_date: { cat: 'typing', label: 'Parse dates', icon: 'Calendar', shortDesc: 'Normalise to ISO / US / EU' },
  parse_number: { cat: 'typing', label: 'Parse numbers', icon: 'Hash', shortDesc: 'Strip $ , % and convert to number' },
  parse_bool: { cat: 'typing', label: 'Parse booleans', icon: 'SquareCheck', shortDesc: 'Y/N · yes/no · 1/0 → true/false' },

  // Row transforms ────────────────────────────────────────────────────
  filter: { cat: 'transform', label: 'Filter rows', icon: 'Filter', shortDesc: 'Keep / drop rows by condition' },
  compute: { cat: 'transform', label: 'Compute column', icon: 'FunctionSquare', shortDesc: 'Derive a new column from an expression' },
  case_when: { cat: 'transform', label: 'If / Then / Else', icon: 'GitBranch', shortDesc: 'Conditional column assignment' },
  regex_extract: { cat: 'transform', label: 'Regex extract', icon: 'Regex', shortDesc: 'Capture matches into a new column' },
  hash: { cat: 'transform', label: 'Hash / mask', icon: 'Fingerprint', shortDesc: 'Hash or mask PII columns' },
  lookup: { cat: 'transform', label: 'Lookup map', icon: 'Map', shortDesc: 'Map keys to values from a dictionary' },

  // Column ops ────────────────────────────────────────────────────────
  rename: { cat: 'columns', label: 'Rename columns', icon: 'PenLine', shortDesc: 'Rename one or more columns' },
  drop_columns: { cat: 'columns', label: 'Drop columns', icon: 'SquareMinus', shortDesc: 'Remove columns from the output' },
  reorder: { cat: 'columns', label: 'Reorder columns', icon: 'MoveHorizontal', shortDesc: 'Change column order' },
  split_column: { cat: 'columns', label: 'Split column', icon: 'SeparatorVertical', shortDesc: 'Split by delimiter into multiple columns' },
  merge_columns: { cat: 'columns', label: 'Merge columns', icon: 'Combine', shortDesc: 'Concatenate columns into one' },

  // Aggregate ─────────────────────────────────────────────────────────
  group_by: { cat: 'aggregate', label: 'Group by', icon: 'Sigma', shortDesc: 'Aggregate rows by key columns' },
  window: { cat: 'aggregate', label: 'Window function', icon: 'SquareStack', shortDesc: 'Rank · row_number · lag / lead' },
  conditional_group: { cat: 'aggregate', label: 'Conditional Group', icon: 'Layers', shortDesc: 'Group code on every row, with control breaks' },
  rolling: { cat: 'aggregate', label: 'Rolling aggregate', icon: 'RotateCw', shortDesc: 'Moving average / rolling sum' },

  // Sort & rank ───────────────────────────────────────────────────────
  sort: { cat: 'sort', label: 'Sort rows', icon: 'ArrowUpDown', shortDesc: 'Sort by one column ascending or descending' },
  top_n: { cat: 'sort', label: 'Top N', icon: 'ArrowUpToLine', shortDesc: 'Keep first / last N rows' },

  // Join & combine ────────────────────────────────────────────────────
  join: { cat: 'join', label: 'Join dataset', icon: 'Combine', shortDesc: 'Inner · left · right · outer · cross' },
  union: { cat: 'join', label: 'Append / union', icon: 'Layers', shortDesc: 'Stack rows from another dataset' },
  fuzzy_match: { cat: 'join', label: 'Fuzzy match', icon: 'Blend', shortDesc: 'Approximate join via similarity' },

  // Reshape ───────────────────────────────────────────────────────────
  pivot: { cat: 'reshape', label: 'Pivot', icon: 'Shuffle', shortDesc: 'Long → wide' },
  unpivot: { cat: 'reshape', label: 'Unpivot / melt', icon: 'Rows3', shortDesc: 'Wide → long' },
  explode: { cat: 'reshape', label: 'Explode arrays', icon: 'Expand', shortDesc: 'Expand array cells into rows' },

  // Validate ──────────────────────────────────────────────────────────
  regex_validate: { cat: 'validate', label: 'Regex validate', icon: 'Regex', shortDesc: 'Flag / drop rows failing a regex' },
  range_check: { cat: 'validate', label: 'Range check', icon: 'SlidersHorizontal', shortDesc: 'Numeric bounds check' },
  assert: { cat: 'validate', label: 'Custom assertion', icon: 'ShieldAlert', shortDesc: 'Row counts · totals · invariants' },

  // Enrich ────────────────────────────────────────────────────────────
  geocode: { cat: 'enrich', label: 'Geocode', icon: 'MapPin', shortDesc: 'Address → lat/lon' },
  currency: { cat: 'enrich', label: 'Currency convert', icon: 'Coins', shortDesc: 'Convert at historical FX rates' },
  api_lookup: { cat: 'enrich', label: 'API lookup', icon: 'Zap', shortDesc: 'Call an external HTTPS API per row' },
  http_request: { cat: 'enrich', label: 'AI Flow', icon: 'Send', shortDesc: 'Send rows to a web API in JSON batches' },
  sentiment: { cat: 'enrich', label: 'Sentiment / NLP', icon: 'Smile', shortDesc: 'Score text columns' },
  classify: { cat: 'enrich', label: 'Classify', icon: 'Tag', shortDesc: 'Rule-based or ML classification' },

  // Feature Engineering ───────────────────────────────────────────────
  min_max_scaling: { cat: 'feature_engineering', subCat: 'scaling', label: 'Min-Max Scaling', icon: 'Scale', shortDesc: 'Scale features to a fixed range' },
  standard_scaling: { cat: 'feature_engineering', subCat: 'scaling', label: 'Standard Scaling', icon: 'Scale', shortDesc: 'Scale features to zero mean and unit variance' },
  robust_scaling: { cat: 'feature_engineering', subCat: 'scaling', label: 'Robust Scaling', icon: 'Scale', shortDesc: 'Scale features using median and IQR that are robust to outliers' },

  ordinal_encoding: { cat: 'feature_engineering', subCat: 'encoding', label: 'Ordinal Encoding', icon: 'Binary', shortDesc: 'Encode categorical features as ordinal integers' },
  one_hot_encoding: { cat: 'feature_engineering', subCat: 'encoding', label: 'One-Hot Encoding', icon: 'Binary', shortDesc: 'Encode categorical features as one-hot vectors' },
  frequency_encoding: { cat: 'feature_engineering', subCat: 'encoding', label: 'Frequency Encoding', icon: 'Binary', shortDesc: 'Encode categorical features based on their frequency' },

  fixed_clipping: { cat: 'feature_engineering', subCat: 'outlier_handling', label: 'Fixed Clipping', icon: 'Scissors', shortDesc: 'Cap or drop outliers using absolute min/max limits' },
  percentile_bounds: { cat: 'feature_engineering', subCat: 'outlier_handling', label: 'Percentile Bounds', icon: 'BarChart3', shortDesc: 'Cap or drop outliers using dynamic quantile trimming' },
  iqr_outlier: { cat: 'feature_engineering', subCat: 'outlier_handling', label: 'IQR Method', icon: 'Ruler', shortDesc: 'Cap or drop outliers using IQR multipliers' },
  zscore_outlier: { cat: 'feature_engineering', subCat: 'outlier_handling', label: 'Z-Score Method', icon: 'TrendingUp', shortDesc: 'Cap or drop outliers using Z-score standard deviations' },

  variance_threshold: { cat: 'feature_engineering', subCat: 'feature_selection', label: 'Variance Threshold', icon: 'BarChart3', shortDesc: 'Drop features with variance below threshold' },
  pearson_correlation: { cat: 'feature_engineering', subCat: 'feature_selection', label: 'Pearson Correlation', icon: 'TrendingUp', shortDesc: 'Filter features by linear correlation with target' },
  spearman_correlation: { cat: 'feature_engineering', subCat: 'feature_selection', label: 'Spearman Correlation', icon: 'TrendingDown', shortDesc: 'Filter features by rank correlation with target' },
  kendall_correlation: { cat: 'feature_engineering', subCat: 'feature_selection', label: 'Kendall Tau Correlation', icon: 'Shuffle', shortDesc: 'Filter features by ordinal association with target' },
  chi2_selection: { cat: 'feature_engineering', subCat: 'feature_selection', label: 'Chi-Square Selection', icon: 'Calculator', shortDesc: 'Filter categorical features via Chi-Square independence test' },
  anova_selection: { cat: 'feature_engineering', subCat: 'feature_selection', label: 'ANOVA F-Value', icon: 'BarChart3', shortDesc: 'Filter numerical features via ANOVA F-test across target classes' },

  text_structural_metrics: { cat: 'feature_engineering', subCat: 'text_features', label: 'Structural Text Metrics', icon: 'Ruler', shortDesc: 'Extract word count, character count, sentence count, and average word length' },

  skew_correction_step: { cat: 'feature_engineering', subCat: 'skew_correction', label: 'Skew Correction', icon: 'Ruler', shortDesc: 'Reduce skew via Square Root or Log Transform (log1p)' },

  // Sample / split ────────────────────────────────────────────────────
  sample: { cat: 'sample', label: 'Random sample', icon: 'Dices', shortDesc: 'Take N rows or a percentage' },
  split_dataset: { cat: 'sample', label: 'Train / test split', icon: 'Columns2', shortDesc: 'Label each row train or test, optionally stratified' },

  // Profile ───────────────────────────────────────────────────────────
  profile_columns: { cat: 'profile', label: 'Profile columns', icon: 'BarChart3', shortDesc: 'Min · max · mean · nulls · cardinality' },
  profile_outliers: { cat: 'profile', label: 'Outlier flag', icon: 'TrendingDown', shortDesc: 'Flag outliers via IQR / z-score / MAD' },

  // Output ────────────────────────────────────────────────────────────
  output: { cat: 'output', label: 'Output file', icon: 'Upload', shortDesc: 'Write CSV / Parquet / Excel / JSON' },
};

// Convenience: lookup category accent for a step
export function stepAccent(stepOrType) {
  const t = typeof stepOrType === 'string' ? stepOrType : stepOrType.type;
  const meta = STEP_TYPES[t];
  if (!meta) return '#3b82f6';
  return meta.accent || CATEGORIES[meta.cat]?.accent || '#3b82f6';
}

// ─── Friendly summaries ────────────────────────────────────────────────
export function summarizeStep(s) {
  const c = s.config || {};
  switch (s.type) {
    case 'source': {
      if (s.label && s.label.includes('·')) return s.label.split('·').slice(1).join('·').trim();
      return 'No file selected';
    }
    case 'source_url': return c.url || 'https://…';
    case 'source_cloud': return c.uri || 's3://…';
    case 'dedupe': return `Key: ${(c.columns || []).join(', ') || '—'}`;
    case 'drop_nulls': return `Drop where ${(c.columns || []).join(', ') || 'any'} is blank`;
    case 'fill_nulls': return `${c.column || '—'} ← "${c.fill ?? ''}"`;
    case 'trim': return `Trim ${(c.columns || []).length ? (c.columns).join(', ') : 'all string columns'}`;
    case 'case': return `${c.column || '—'} → ${(c.mode || 'lower').toUpperCase()}`;
    case 'strip_chars': return `${c.column || '—'} ✕ "${c.chars || ''}"`;
    case 'left_trim': return `LTrim${c.count != null ? `(${c.count})` : ''} ${(c.columns || []).length ? (c.columns).join(', ') : 'all string columns'}`;
    case 'right_trim': return `RTrim${c.count != null ? `(${c.count})` : ''} ${(c.columns || []).length ? (c.columns).join(', ') : 'all string columns'}`;
    case 'mid': return `${c.column || '—'}[${c.start ?? 0}:${c.length ?? ''}]`;
    case 'find_replace': return `${c.column || '—'} "${c.find || ''}" → "${c.replace ?? ''}"`;
    case 'cast_type': return `${c.column || '—'} → ${(c.target || 'string').toUpperCase()}`;
    case 'parse_date': return `${c.column || '—'} → ${c.format || 'ISO'}`;
    case 'parse_number': return `${c.column || '—'} → number`;
    case 'parse_bool': return `${c.column || '—'} → boolean`;
    case 'filter': {
      const n = (c.conditions || []).length;
      const mode = c.mode === 'keep' ? 'KEEP' : 'DROP';
      return `${mode} where ${n} condition${n === 1 ? '' : 's'} (${c.conjunction || 'AND'})`;
    }
    case 'compute': {
      if (c.logic_mode === 'code') {
        // Mirrors codeMode/blockCode.js's isCodeBlock/needsBlockReview (data.js stays import-free).
        return `${c.target || '—'} ← Code${c.code && c.code.reviewed === false ? ' · needs review' : ''}`;
      }
      return `${c.target || '—'} = ${c.expression || '?'}`;
    }
    case 'case_when': {
      if (c.logic_mode === 'code') {
        // Mirrors codeMode/blockCode.js codeBlockSummary (data.js stays import-free).
        const outs = 1 + (c.extra_outputs || []).length;
        return `${c.target || '—'} ← Code · ${outs} output${outs === 1 ? '' : 's'}${c.code && c.code.reviewed === false ? ' · needs review' : ''}`;
      }
      const n = (c.cases || []).length;
      const nCode = (c.cases || []).filter(cs => cs && cs.mode === 'code').length;
      const extras = [nCode ? `${nCode} in code` : '', c.else_mode === 'keep' ? 'else keeps value' : '', c.write_mode === 'only_if_blank' ? 'only if blank' : ''].filter(Boolean);
      const more = (c.extra_outputs || []).length;
      if (more) extras.unshift(`+${more} more column${more === 1 ? '' : 's'}`);
      return `${c.target || '—'} ← ${n} case${n === 1 ? '' : 's'}${extras.length ? ` · ${extras.join(', ')}` : ''}`;
    }
    case 'regex_extract': return `${c.target || c.column + '_x'} ← /${c.pattern || ''}/`;
    case 'hash': return `${c.column || '—'} ← ${(c.mode || 'hash').toUpperCase()}`;
    case 'lookup': return `${c.column || '—'} via ${Object.keys(c.map || {}).length}-entry map`;
    case 'rename': return `Rename ${Object.keys(c.renames || {}).length} column${Object.keys(c.renames || {}).length === 1 ? '' : 's'}`;
    case 'drop_columns': return `Drop ${(c.columns || []).join(', ') || '—'}`;
    case 'reorder': return `${(c.order || []).length} columns reordered`;
    case 'split_column': return `${c.column || '—'} → [${(c.into || []).join(', ')}]`;
    case 'merge_columns': return `[${(c.columns || []).join(', ')}] → ${c.target || '—'}`;
    case 'group_by': return `By ${(c.keys || []).join(', ') || '—'} · ${(c.aggs || []).length} agg`;
    case 'window': return `${c.fn || '—'} over ${(c.partition || []).join(',') || '—'}`;
    case 'conditional_group': return `${(c.target || '').trim() || 'GroupCode'} by ${(c.keys || []).join(', ') || 'all rows'} · ${(c.breaks || []).length} break${(c.breaks || []).length === 1 ? '' : 's'}`;
    case 'rolling': return `${c.fn || 'avg'} window ${c.window || '7'}`;
    case 'sort': {
      const keys = (c.keys && c.keys.length)
        ? c.keys
        : (c.column ? [{ column: c.column, dir: c.dir || 'asc' }] : []);
      if (keys.length === 0) return '—';
      return keys.map(k => `${k.column} ${k.dir === 'desc' ? '↓' : '↑'}`).join(' · ');
    }
    case 'top_n': return `${c.from === 'bottom' ? 'Bottom' : 'Top'} ${c.n ?? 10}`;
    case 'join': {
      const jKeys = (c.keys && c.keys.length) ? c.keys : [{ left: c.on || '—', right: c.rightOn || '—' }];
      const keyStr = jKeys.map(k => `${k.left}=${k.right}`).join(', ');
      return `${(c.kind || 'inner').toUpperCase()} JOIN ${c.right || '—'} on ${keyStr}`;
    }
    case 'union': return `+ ${c.right || '—'}`;
    case 'fuzzy_match': return `≈ ${c.right || '—'} · ${c.threshold ?? 0.85}`;
    case 'pivot': return `Index ${c.index || '—'} · cols ${c.columns_pivot || '—'}`;
    case 'unpivot': return `${(c.id_vars || []).length} id columns`;
    case 'explode': return `${c.column || '—'} → rows`;
    case 'regex_validate': return `${c.column || '—'} ≟ /${c.pattern || ''}/`;
    case 'range_check': return `${c.column || '—'} ∈ [${c.min ?? '−∞'}, ${c.max ?? '+∞'}]`;
    case 'assert': return c.note || 'Custom assertion';
    case 'geocode': return `${c.column || '—'} → lat,lon`;
    case 'currency': return `${c.column || '—'} ${c.from || 'USD'} → ${c.to || 'EUR'}`;
    case 'api_lookup': return `${c.method || 'GET'} ${c.url || '—'}`;
    case 'http_request': return `${c.method || 'POST'} ${(c.url || '').replace(/^https?:\/\//, '') || '—'} · batch ${c.batch_size || 1}`;
    case 'sentiment': return `${c.column || '—'} → score`;
    case 'classify': return `${c.column || '—'} → ${c.target || 'class'}`;
    case 'min_max_scaling': return `Min-Max: ${c.range === '-1,1' ? '[-1, 1]' : '[0, 1]'}`;
    case 'standard_scaling': return `Z-Score`;
    case 'robust_scaling': return `Robust`;
    case 'ordinal_encoding': return `Ordinal`;
    case 'one_hot_encoding': return `One-Hot`;
    case 'frequency_encoding': return `Frequency`;
    case 'fixed_clipping': return `Fixed Clip (${c.action || 'clip'})`;
    case 'percentile_bounds': return `Percentile [${c.lower_quantile ?? 0.01}, ${c.upper_quantile ?? 0.99}] (${c.action || 'clip'})`;
    case 'iqr_outlier': return `IQR k=${c.k ?? 1.5} (${c.action || 'clip'})`;
    case 'zscore_outlier': return `Z-Score z=${c.z ?? 3.0} (${c.action || 'clip'})`;
    case 'variance_threshold': return `Var ≥ ${c.threshold ?? 0.0}`;
    case 'pearson_correlation': return `Pearson |r| ≥ ${c.threshold ?? 0.05} (${c.target || 'target'})`;
    case 'spearman_correlation': return `Spearman |ρ| ≥ ${c.threshold ?? 0.05} (${c.target || 'target'})`;
    case 'kendall_correlation': return `Kendall |τ| ≥ ${c.threshold ?? 0.05} (${c.target || 'target'})`;
    case 'chi2_selection': return `Chi² p ≤ ${c.max_p_value ?? 0.05} (${c.target || 'target'})`;
    case 'anova_selection': return `ANOVA p ≤ ${c.max_p_value ?? 0.05} (${c.target || 'target'})`;
    case 'text_structural_metrics': return `Text metrics (${(c.columns || []).length} cols)`;
    case 'skew_correction_step': return `${c.column || '—'} → ${c.method === 'sqrt' ? 'Sqrt' : 'Log1p'}`;
    case 'sample': return c.pct ? `${c.pct}%` : `n=${c.n ?? 1000}`;
    case 'split_dataset': return `${Math.round(((c.ratio ?? 0.8)) * 100)}% / ${Math.round((1 - (c.ratio ?? 0.8)) * 100)}%`;
    case 'output': return `${(c.format || 'csv').toUpperCase()} · ${c.filename || 'output'}`;
    default: return STEP_TYPES[s.type]?.shortDesc || '';
  }
}

// ── Output filename template tokens ─────────────────────────────────────
// Used by the output inspector + run modal to render insert chips and
// resolve a live preview.
export const FILENAME_TOKENS = [
  { token: '{run_id}', label: 'Run ID', desc: 'Unique ID assigned to this run', group: 'run' },
  { token: '{input_name}', label: 'Input name', desc: 'Input filename without extension', group: 'input' },
  { token: '{input_file}', label: 'Input file', desc: 'Full input filename (incl. extension)', group: 'input' },
  { token: '{input_ext}', label: 'Input ext', desc: 'Extension of the input file', group: 'input' },
  { token: '{date}', label: 'Date', desc: 'YYYY-MM-DD', group: 'date' },
  { token: '{time}', label: 'Time', desc: 'HH-MM-SS', group: 'date' },
  { token: '{yyyy}', label: 'Year', desc: '4-digit year', group: 'date' },
  { token: '{mm}', label: 'Month', desc: '2-digit month', group: 'date' },
  { token: '{dd}', label: 'Day', desc: '2-digit day', group: 'date' },
  { token: '{hh}', label: 'Hour', desc: '2-digit hour (24h)', group: 'date' },
  { token: '{mn}', label: 'Minute', desc: '2-digit minute', group: 'date' },
  { token: '{ss}', label: 'Second', desc: '2-digit second', group: 'date' },
  { token: '{seq:0001}', label: 'Sequence', desc: 'Running counter (pad by digit count)', group: 'seq' },
];

// Recently-used / suggested output folder paths surfaced in the picker.
export const OUTPUT_FOLDERS = [
  { path: '/Users/dpipe/Exports/Customers', hint: 'Used by 3 pipelines', recent: true },
  { path: '/Users/dpipe/Exports/Inventory', hint: 'Used by 2 pipelines', recent: true },
  { path: '/Users/dpipe/Exports/Finance', hint: 'Used by 4 pipelines', recent: true },
  { path: '/Users/dpipe/Exports/HR', hint: 'Used by 1 pipeline' },
  { path: '/Users/dpipe/Exports/Support', hint: 'Used by 1 pipeline' },
  { path: '/Users/dpipe/Exports/Daily', hint: 'Auto-run drop' },
  { path: '/mnt/warehouse/landing/clean', hint: 'Mounted NFS share' },
  { path: 's3://acme-dpipe/exports/', hint: 'S3 bucket' },
];

// Expand all `{token}` placeholders against the given context. Unknown
// tokens are preserved verbatim so the user notices typos in the preview.
// The server has an identical port — see server/app/routers/runs.py
// `_resolve_filename` — which is the canonical resolver at run time. This
// client version just powers the live preview in the output inspector.
export function resolveFilenamePattern(pattern, ctx = {}) {
  const runId = ctx.runId || 'R-026-A93';
  const inputFile = ctx.inputFile || 'input.csv';
  const now = ctx.now || new Date();
  const seq = ctx.seq != null ? ctx.seq : 1;

  const pad = (n, len) => String(n).padStart(len, '0');
  const inputName = inputFile.replace(/\.[^.]+$/, '');
  const inputExt = (inputFile.match(/\.([^.]+)$/) || ['', ''])[1] || '';
  const yyyy = pad(now.getFullYear(), 4);
  const yy = pad(now.getFullYear() % 100, 2);
  const mm = pad(now.getMonth() + 1, 2);
  const dd = pad(now.getDate(), 2);
  const hh = pad(now.getHours(), 2);
  const mn = pad(now.getMinutes(), 2);
  const ss = pad(now.getSeconds(), 2);

  const lookup = {
    run_id: runId, input_file: inputFile, input_name: inputName, input_ext: inputExt,
    date: `${yyyy}-${mm}-${dd}`, time: `${hh}-${mn}-${ss}`,
    yyyy, yy, mm, dd, hh, mn, ss,
  };

  return String(pattern || '').replace(/\{([^}]+)\}/g, (whole, body) => {
    if (body === 'seq') return pad(seq, 4);
    const m = body.match(/^seq:(\d+)$/);
    if (m) return pad(seq, m[1].length);
    if (Object.prototype.hasOwnProperty.call(lookup, body)) return lookup[body];
    return whole;
  });
}

// ── Right-side mock dataset (orders, joinable on customer id) ────────────
// Available as a sample secondary dataset in the join inspector until the
// /api/datasets uploader replaces the in-browser sample catalog.
export const ORDERS_ROWS = [
  { order_id: 'ORD-001', customer_id: 1001, product: 'Pro Plan', amount: 480, order_date: '2025-09-15', region: 'NA' },
  { order_id: 'ORD-002', customer_id: 1003, product: 'Enterprise Suite', amount: 1850, order_date: '2025-07-10', region: 'APAC' },
  { order_id: 'ORD-003', customer_id: 1006, product: 'Team Add-on', amount: 240, order_date: '2025-11-08', region: 'APAC' },
  { order_id: 'ORD-004', customer_id: 1001, product: 'API Credits', amount: 120, order_date: '2025-10-22', region: 'NA' },
  { order_id: 'ORD-005', customer_id: 1008, product: 'Enterprise Suite', amount: 2100, order_date: '2025-06-01', region: 'EMEA' },
  { order_id: 'ORD-006', customer_id: 1010, product: 'Pro Plan', amount: 480, order_date: '2025-11-02', region: 'EMEA' },
  { order_id: 'ORD-007', customer_id: 1012, product: 'Team Starter', amount: 240, order_date: '2025-12-20', region: 'EMEA' },
  { order_id: 'ORD-008', customer_id: 1016, product: 'Enterprise Suite', amount: 2100, order_date: '2025-04-15', region: 'NA' },
  { order_id: 'ORD-009', customer_id: 1022, product: 'Enterprise Suite', amount: 2100, order_date: '2025-05-20', region: 'LATAM' },
  { order_id: 'ORD-010', customer_id: 9999, product: 'Legacy Import', amount: 50, order_date: '2025-01-05', region: 'NA' },
];

export const ORDERS_COLUMNS = [
  { name: 'order_id', type: 'string' },
  { name: 'customer_id', type: 'number' },
  { name: 'product', type: 'string' },
  { name: 'amount', type: 'number' },
  { name: 'order_date', type: 'string' },
  { name: 'region', type: 'string' },
];

// ── Input file browser catalog (mock) ───────────────────────────────────
// Surfaced by FileBrowserModal as "recent / project / samples" tabs until
// the /api/datasets uploader replaces it.
export const INPUT_FILES = [
  { name: 'customers_export_2026-05.csv', size: '142 KB', sizeBytes: 145408, rows: 24, format: 'csv', modified: '2026-05-21 09:14', location: 'recent', folder: 'Imports/CRM' },
  { name: 'orders.csv', size: ' 4 KB', sizeBytes: 4096, rows: 10, format: 'csv', modified: '2026-05-10 16:30', location: 'samples', folder: 'Sample Data' },
];

// Steps and input modes that appear in the UI but have no working backend yet.
// Shown greyed out with a "Phase 2" badge (see StepPalette / FileBrowserModal).
// Step types that accept the optional "Apply only when" gate (config key
// `apply_when`). The value is purely descriptive (every entry behaves
// identically — unchanged raw passthrough on a False row); only key presence
// is read (StepInspector.jsx). Literal mirror of GATEABLE in
// server/app/engine/row_gate.py — keep in sync.
export const GATEABLE_STEPS = {
  split_column: '1:1 map',
  rename: '1:1 map',
  drop_columns: '1:1 map (Source-anchored)',
  reorder: '1:1 map (Source-anchored)',
  merge_columns: '1:1 map',
  dedupe: 'row-reducing — a False row always survives, even a duplicate',
  drop_nulls: 'row-reducing in drop mode, 1:1 in flag mode',
  fill_nulls: '1:1 map',
  trim: '1:1 map',
  case: '1:1 map',
  strip_chars: '1:1 map',
  left_trim: '1:1 map',
  right_trim: '1:1 map',
  mid: '1:1 map',
  find_replace: '1:1 map',
  cast_type: '1:1 map',
  parse_date: '1:1 map',
  parse_number: '1:1 map',
  parse_bool: '1:1 map',
  compute: '1:1 map (Source-anchored)',
  regex_extract: '1:1 map',
  hash: '1:1 map',
  lookup: '1:1 map',
  sort: 'reshaping — gated-in rows are sorted; gated-out rows are appended after, in original order',
  top_n: 'reshaping — gated-in rows compete for the top N; gated-out rows are appended after, unranked',
  group_by: 'reshaping (Source-anchored) — gated-in rows are grouped; gated-out rows are appended after, raw',
  window: '1:1 map over gated-in rows (their own partition/order), gated-out rows pass through in place',
  rolling: '1:1 map over gated-in rows in original order; gated-out rows pass through in place',
  conditional_group: '1:1 map over gated-in rows (their own keys/order/breaks), gated-out rows pass through in place, uncoded',
  pivot: 'reshaping — gated-in rows are pivoted; gated-out rows are appended after, raw',
  unpivot: 'reshaping (Source-anchored) — gated-in rows are melted; gated-out rows are appended after, raw',
  explode: 'reshaping — gated-in rows are exploded; gated-out rows are appended after, raw',
  sample: 'row-reducing — gated-out rows are always kept, outside the sample size',
  split_dataset: 'reshaping (it shuffles) — gated-in rows are labeled train/test; gated-out rows are appended after, unlabeled',
  union: 'reshaping — gated-in self rows are unioned; gated-out self rows are appended after, raw',
  fuzzy_match: 'reshaping — gated-in rows are matched; gated-out rows are appended after, raw',
  regex_validate: 'row-reducing in drop mode, 1:1 in flag mode',
  range_check: 'row-reducing in drop mode, 1:1 in flag mode',
  assert: 'row-reducing in drop mode, 1:1 in flag mode',
  geocode: '1:1 map',
  currency: '1:1 map',
  api_lookup: '1:1 map',
  http_request: '1:1 map — only gated-in rows are sent; held-out rows are not sent and get no result columns',
  sentiment: '1:1 map',
  classify: '1:1 map',
  profile_columns: '1:1 passthrough — stats are computed only from gated-in rows',
  profile_outliers: '1:1 map',
  min_max_scaling: '1:1 map — fit is computed only from gated-in rows',
  standard_scaling: '1:1 map — fit is computed only from gated-in rows',
  robust_scaling: '1:1 map — fit is computed only from gated-in rows',
  ordinal_encoding: '1:1 map — fit is computed only from gated-in rows',
  one_hot_encoding: '1:1 map — fit is computed only from gated-in rows',
  frequency_encoding: '1:1 map — fit is computed only from gated-in rows',
  fixed_clipping: '1:1 map in clip mode, row-reducing in drop mode',
  percentile_bounds: '1:1 map in clip mode, row-reducing in drop mode',
  iqr_outlier: '1:1 map in clip mode, row-reducing in drop mode',
  zscore_outlier: '1:1 map in clip mode, row-reducing in drop mode',
  variance_threshold: '1:1 passthrough — audit is computed only from gated-in rows',
  pearson_correlation: '1:1 passthrough — audit is computed only from gated-in rows',
  spearman_correlation: '1:1 passthrough — audit is computed only from gated-in rows',
  kendall_correlation: '1:1 passthrough — audit is computed only from gated-in rows',
  chi2_selection: '1:1 passthrough — audit is computed only from gated-in rows',
  anova_selection: '1:1 passthrough — audit is computed only from gated-in rows',
  text_structural_metrics: '1:1 map',
  skew_correction_step: '1:1 map',
};

export const PHASE2_LABEL = 'Phase 2';
export const PHASE2_TOOLTIP = 'Pushed to Phase 2 — not available yet.';
export const PHASE2_STEPS = new Set(['profile_columns', 'fuzzy_match', 'api_lookup', 'source_url', 'source_cloud', 'geocode', 'currency', 'sentiment', 'classify']);

// ── Real rows behind catalog filenames ──────────────────────────────────
// INPUT_FILES now lists only these two — the app ships their actual rows (and the catalog row counts match — 24 and 10), so
// picking them can show real data in the preview instead of an empty panel.
// Anything not listed here has no data to show until it's really uploaded.
export const CATALOG_DATASETS = {
  'customers_export_2026-05.csv': { rows: SOURCE_ROWS, columns: SOURCE_COLUMNS },
  'orders.csv': { rows: ORDERS_ROWS, columns: ORDERS_COLUMNS },
};
